import viewerQuery from 'graphql/queries/viewerQuery'
import AppLayout from 'layouts/AppLayout/components/AppLayout'
import React from 'react'
import { getLocalStorageToken } from 'store/localStorage'
import { useQuery } from "@apollo/client/react";
import {
  viewerQuery as viewerQueryType,
  viewerQueryVariables,
} from 'graphql/queries/types/viewerQuery'

export const LOGOUT = 'LOGOUT'
export const TOGGLE_DRAWER = 'TOGGLE_DRAWER'
export const TOGGLE_USER_SETTINGS = 'TOGGLE_USER_SETTINGS'

export interface IAppLayoutState {
  drawerOpen: boolean
  userSettingsOpen: boolean
}

const initialState: IAppLayoutState = {
  drawerOpen: false,
  userSettingsOpen: false,
}
export default function appLayoutReducer(
  state: IAppLayoutState = initialState,
  action: any,
): IAppLayoutState {
  switch (action.type) {
    case LOGOUT:
      return { ...state, userSettingsOpen: false }
    case TOGGLE_DRAWER:
      return { ...state, drawerOpen: action.payload }
    case TOGGLE_USER_SETTINGS:
      return { ...state, userSettingsOpen: action.payload }
    default:
      return state
  }
}

export const AppLayoutContainer: React.FC = () => {
  const { data } = useQuery<viewerQueryType, viewerQueryVariables>(viewerQuery, {
    variables: { token: getLocalStorageToken() },
  })

  return data ? (
    <AppLayout changePassword={data?.viewer?.changePassword ? 1 : 0} />
  ) : null
}
